import { IconButton, Snackbar } from "@mui/material";
import { ReactElement } from "react";
import CloseIcon from "@mui/icons-material/Close";

interface Props {
  open: boolean;
  content: ReactElement;
  onClose: () => void;
}

export const InvoiceSnackbar = ({ open, onClose, content }: Props) => {
  const DRAWER_WIDTH = "256px";

  const closeButton = (
    <IconButton onClick={onClose} size="small">
      <CloseIcon sx={{ color: "rgba(255, 255, 255, 1)" }} fontSize="small" />
    </IconButton>
  );

  return (
    <Snackbar
      sx={{
        paddingLeft: DRAWER_WIDTH,
        "& .MuiSnackbarContent-root": {
          minWidth: "auto",
        },
        "& .MuiSnackbarContent-action": {
          paddingLeft: "0px",
          marginLeft: "0.75rem",
          marginRight: "0px",
        },
      }}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      open={open}
      onClose={onClose}
      autoHideDuration={6000}
      message={content}
      action={closeButton}
    />
  );
};
